import { writable } from 'svelte/store';

// Types
import type { Writable } from 'svelte/store';
import type { Testimonial } from '$lib/types/Testimonial';

export interface SliderController {
    rawOffset: number;
    offset: Writable<number>;
    interval: NodeJS.Timer | undefined;
    start: () => void;
    restart: () => void;
    next: () => void;
    back: () => void;
}

const createSliderController = (
    items: Testimonial[] | string[],
    duration = 5000,
): SliderController => {
    const controller: SliderController = {
        rawOffset: 0,
        offset: writable(0),
        interval: undefined,
        start: () => {
            return;
        },
        restart: () => {
            return;
        },
        next: () => {
            return;
        },
        back: () => {
            return;
        },
    };

    controller.start = () => {
        controller.interval = setInterval(() => {
            if (controller.rawOffset < items.length - 1) {
                controller.rawOffset++;
                controller.offset.set(controller.rawOffset);
            } else {
                controller.rawOffset = 0;
                controller.offset.set(controller.rawOffset);
            }
        }, duration);
    };

    controller.restart = () => {
        clearInterval(controller.interval);
        controller.start();
    };

    controller.next = () => {
        if (controller.rawOffset + 1 < items.length) {
            controller.rawOffset++;
            controller.offset.set(controller.rawOffset);
            controller.restart();
        } else {
            controller.rawOffset = 0;
            controller.offset.set(controller.rawOffset);
            controller.restart();
        }
    };

    controller.back = () => {
        if (controller.rawOffset - 1 >= 0) {
            controller.rawOffset--;
            controller.offset.set(controller.rawOffset);
            controller.restart();
        } else {
            controller.rawOffset = items.length - 1;
            controller.offset.set(controller.rawOffset);
            controller.restart();
        }
    };

    return controller;
};

export default createSliderController;
